import {useQuery} from "@tanstack/react-query";
import {getData} from "../../../app/getters/getData.js";


export const useUprawnienia = (enabled = true, kcId) => {


    return useQuery({
        queryKey: ['uprawnienia', kcId],
        queryFn: async () => getData(`/uzytkownik/uprawnienia`),
        gcTime: 1000 * 60 * 30,
        enabled
    })
}